<template>
  <div class="no-active-campaign">
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          20<br>
          ГОДИНИ
        </div>
      </div>
      <div class="info-box-content">
        софтуер за<br>
        образованието
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          ПЪРВИ
        </div>
      </div>
      <div class="info-box-content">
        електронен<br>
        дневник
      </div>
    </div>
    <div class="info-box active d-flex mb-3">
      <div class="info-box-title">
        <div>
          ДО ВАС
        </div>
      </div>
      <div class="info-box-content">
        винаги и<br>
        навреме
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "no-active-slogan-component"
}
</script>

<style scoped>
.info-box {
  width: 300px;
}

.info-box-title {
  flex-basis: 120px;
  height: 80px;
  font-size: 1rem;
}
</style>
